import { D18, D19, D20, D21, D22, D23, D24, D25 } from "./masterConstrain";

const MASTER_DATA_CACHE = new Map<string, Map<string, any>>();

const loadCohortData = async (course: string): Promise<Map<string, any>> => {
  if (MASTER_DATA_CACHE.has(course)) {
    return MASTER_DATA_CACHE.get(course)!;
  }

  let cohortData: Map<string, any>;

  switch (course) {
    case D18:
      cohortData = (await import("./D18/_d18MasterData")).D18_MASTER_DATA;
      break;
    case D19:
      cohortData = (await import("./D19/_d19MasterData")).D19_MASTER_DATA;
      break;
    case D20:
      cohortData = (await import("./D20/_d20MasterData")).D20_MASTER_DATA;
      break;
    case D21:
      cohortData = (await import("./D21/_d21MasterData")).D21_MASTER_DATA;
      break;
    case D22:
      cohortData = (await import("./D22/_d22MasterData")).D22_MASTER_DATA;
      break;
    case D23:
      cohortData = (await import("./D23/_d23MasterData")).D23_MASTER_DATA;
      break;
    case D24:
      cohortData = (await import("./D24/_d24MasterData")).D24_MASTER_DATA;
      break;
    case D25:
      cohortData = (await import("./D25/_d25MasterData")).D25_MASTER_DATA;
      break;
    default:
      cohortData = new Map();
  }

  MASTER_DATA_CACHE.set(course, cohortData);
  return cohortData;
};

export const EXCHANGEABLE_SUBJECT_IDS = [
  "BAS1158",
  "BAS1160",
  "BAS1156",
  "BAS1146",
  "BAS1145",
  "BAS1142",
  "BAS1157",
  "BAS1148",
  "BAS1159",
  "BAS1141",
  "BAS1147",
  "BAS1143",
  "BAS1144",
];

export const getMasterCourseKeyList = () => {
  return [D18, D19, D20, D21, D22, D23, D24, D25];
};

export const getMasterMajorKeyList = async (course: string) => {
  if (!course) return [];
  const courseMaster = await loadCohortData(course);
  return courseMaster ? Array.from(courseMaster.keys()) : [];
};

export const getMasterMajor = async (course: string, major: string) => {
  const courseMaster = await loadCohortData(course);
  return courseMaster?.get(major);
};
